import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-project',
  template: require('./project.component.html'),
  styles: [require('./project.component.scss')],
})
export class ProjectComponent implements OnInit, OnDestroy {
  project: any;

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.route.data.subscribe(resolved => this.project = resolved.project);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/art/project.component.ts